// extracted by mini-css-extract-plugin
export default {"ModalContent":"📚19-10-2EYuNB"};